// actions/schoolAppointmentActions.js
import {
    SCHOOL_CREATE_APPOINTMENT_REQUEST,
    SCHOOL_CREATE_APPOINTMENT_SUCCESS,
    SCHOOL_RESET_APPOINTMENT_STATE,
  } from './schoolAppointmentTypes';
  
  // Action to initiate school appointment creation
  export const createSchoolAppointmentRequest = (schoolAppointmentData) => ({
    type: SCHOOL_CREATE_APPOINTMENT_REQUEST,
    payload: schoolAppointmentData,
  });
  
  // Action for successful school appointment storage
  export const createSchoolAppointmentSuccess = (schoolAppointment) => ({
    type: SCHOOL_CREATE_APPOINTMENT_SUCCESS,
    payload: schoolAppointment,
  });
  
  // Action to reset school appointment state
  export const resetSchoolAppointmentState = () => ({
    type: SCHOOL_RESET_APPOINTMENT_STATE,
  });
  
  // Action creator to handle school appointment storage (synchronous)
  export const createSchoolAppointment = (schoolAppointmentData) => (dispatch) => {
    dispatch(createSchoolAppointmentRequest(schoolAppointmentData));
    dispatch(createSchoolAppointmentSuccess(schoolAppointmentData));
  };